import * as yup from 'yup'

export class VehicleCheckInRearCornerPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInRearCornerPhotoFile?: File = undefined
}

export const vehicleCheckInRearCornerPhotoValidationSchema = yup.object({
  vehicleCheckInRearCornerPhotoFile: yup.mixed().notRequired()
})
